// overlay.js

$(function() {

	var scroll = $(window).scrollTop(),
		overlaySelector = '.overlay',
		overlayContentSelector = '.overlay__content',
		overlayHiddenContentSelector = '.overlay__content--hidden',
		overlay = $(overlaySelector),
		content = overlay.find(overlayContentSelector);

	$(document).on('click', '.js-overlay-open', function(event) {
		var item = $(this),
			target = item.attr('data-target');

		scroll = $(window).scrollTop();

		overlay.trigger('open.overlay', {
			scroll: scroll,
			target: target
		});

		event.preventDefault();
	});

	$(document).on('click', '.js-overlay-close', function(event) {
		event.preventDefault();

		var elem = $(this);
		overlay.trigger('close.overlay', {
			href: elem.attr('href'),
			title: elem.attr('title')
		});

	});

	$(document).on('click', 'body.overlay-open', function(event) { 
		if(!$(event.target).closest('.overlay__detail').length && !$(event.target).is('.overlay__detail')) {
			$('.js-overlay-close').trigger('click');
		}
	})


	// setup handler
	overlay.one('setup.overlay', function() {

		overlay.trigger('reset.overlay');

	});

	// reset handler
	overlay.on('reset.overlay', function() {
		content.html('');
	});

	// close handler
	// overlay.add(document).on('close.overlay', function(event, data) {
	overlay.on('close.overlay', function(event, data) {

		$('.page').removeClass('overlay-open');
		$('.page__stage').css('top', 'auto');
		$(window).scrollTop(scroll);
		overlay.trigger('reset.overlay');

	});

	// populate handler
	overlay.on('populate.overlay', function(event, data) {
		
		var overlayData = '';

		overlay.trigger('reset.overlay');

		overlayData = $(overlayHiddenContentSelector).filter(data.target).html();
		content.append(overlayData);

	});

	overlay.on('open.overlay', function(event, data) {

		overlay.trigger('populate.overlay', data);

		$('.page').addClass('overlay-open');
		$('.page__stage').css('top', '-' + data.scroll + 'px');

	});

	overlay.trigger('setup.overlay');

});

$(function() {

	$(document).on('click', '.js-scroll-to', function(event) {

		event.preventDefault();

		var self = $(this),
			target = self.attr('data-target');

		$('html, body').animate({
			scrollTop: $(target).offset().top
		}, 1000);

	});

});

function initialize() {

	var myLatlng = new google.maps.LatLng(47.156031, 9.820187);
	var mapStyles = [{"featureType":"landscape","stylers":[{"hue":"#FFBB00"},{"saturation":43.400000000000006},{"lightness":37.599999999999994},{"gamma":1}]},{"featureType":"road.highway","stylers":[{"hue":"#FFC200"},{"saturation":-61.8},{"lightness":45.599999999999994},{"gamma":1}]},{"featureType":"road.arterial","stylers":[{"hue":"#FF0300"},{"saturation":-100},{"lightness":51.19999999999999},{"gamma":1}]},{"featureType":"road.local","stylers":[{"hue":"#FF0300"},{"saturation":-100},{"lightness":52},{"gamma":1}]},{"featureType":"water","stylers":[{"hue":"#0078FF"},{"saturation":-13.200000000000003},{"lightness":2.4000000000000057},{"gamma":1}]},{"featureType":"poi","stylers":[{"hue":"#00FF6A"},{"saturation":-1.0989010989011234},{"lightness":11.200000000000017},{"gamma":1}]}];
	var mapOptions = {
		zoom: 15,
		center: myLatlng,
		styles: mapStyles,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		scrollwheel: false,
		navigationControl: false,
		mapTypeControl: false,
		scaleControl: false,
		disableDefaultUI: true,
		disableDoubleClickZoom: true,
		draggable: false
	}
	var map = new google.maps.Map(document.getElementById('map__canvas'), mapOptions);

	var markerIcon = {
		path: 'M15,0C6.716,0,0,6.716,0,15c0,11.945,15,25.842,15,25.842S30,26.945,30,15C30,6.716,23.285,0,15,0z\
	 M15,20.796c-3.202,0-5.796-2.595-5.796-5.795c0-3.201,2.595-5.795,5.796-5.795c3.201,0,5.794,2.594,5.794,5.795\
	S18.201,20.796,15,20.796z',
		fillColor: '#461b04',
		fillOpacity: 1,
		scale: 1,
		strokeWeight: 0,
		size: new google.maps.Size(30, 41),
		origin: new google.maps.Point(0,0),
		anchor: new google.maps.Point(15, 41)
	};

	//=====Initialise Default Marker    
	var marker = new google.maps.Marker({
		icon: markerIcon,
		position: myLatlng,
		map: map,
		title: 'marker'
	//=====You can even customize the icons here
	});

	//=====Eventlistener for InfoWindow
	google.maps.event.addListener(marker, 'click', function() {
		infowindow.open(map,marker);
	});
}

google.maps.event.addDomListener(window, 'load', initialize);
